import React from 'react';
import styles from "./style.module.scss";
import "./style.css"

export default function About() {
  return (
    <>
     <section class="about" id='About'>
     <div class="sec-title">
                    		<div class="title">
                            <h1 class="home-title about-title"><strong>About</strong></h1>
                            </div>
                            <h2 style={{fontWeight:"700"}}>Hello, I am Asfer</h2></div>
                        <div ><p class="text">
                        I'm a full-stack developer based in Chennai, where design and branding hold a special place in my work. Rather than calling it "my passion," I'm more interested in pushing creative boundaries without falling into clichés. Since graduating in 2022, as a fresher, I am eagerly seeking opportunities to work and design passionately. I'm enthusiastic about starting my journey in web design firms and tech companies. My hunger to learn and grow is insatiable. Whether it's my inherent determination or my constant desire for improvement, I'm always on a quest to sharpen my skills and explore new design disciplines.
                          </p></div>
    </section>
    </>
  )
}
